import PostStore from "../../services/Store"

export default {
    install: () => {
        PostStore.setChannels().then(() => {})
    }
}
